import type { ResolveMapEntry, TargetEnvironment } from '@ms-cloudpack/common-types';
import { isExternalPackage } from '@ms-cloudpack/path-utilities';
import type { RemoteCacheClientOperationOptions } from '@ms-cloudpack/remote-cache';
import { createRemoteCacheClientOperationOptions } from './createRemoteCacheClientOperationOptions.js';
import type { PartialContext } from '../types/Context.js';

export async function getPackagesToSync(
  options: { targetEnvironment: TargetEnvironment },
  context: PartialContext<'packages' | 'packageHashes', 'resolveMap' | 'cachePath' | 'config'>,
): Promise<RemoteCacheClientOperationOptions[]> {
  const { targetEnvironment } = options;
  const { session } = context;
  const { resolveMap } = session;
  const list: RemoteCacheClientOperationOptions[] = [];

  await processEntries({ entries: Object.values(resolveMap), list, targetEnvironment }, context);

  return list;
}

async function processEntries(
  options: {
    targetEnvironment: TargetEnvironment;
    entries: ResolveMapEntry[];
    list: RemoteCacheClientOperationOptions[];
  },
  context: PartialContext<'packages' | 'packageHashes', 'cachePath' | 'config'>,
): Promise<void> {
  const { entries, list, targetEnvironment } = options;
  const syncInternalPackages = context.session.config.features || {};

  for (const { path: packagePath, scopedVersions } of entries) {
    if (isExternalPackage(packagePath) || syncInternalPackages) {
      list.push(await createRemoteCacheClientOperationOptions({ packagePath, targetEnvironment }, context));
    }

    if (scopedVersions) {
      await processEntries({ list, entries: Object.values(scopedVersions), targetEnvironment }, context);
    }
  }
}
